import { PaginationSchema } from './pagination';
import { CleanSchema, get } from '../../json-transform';

export const getCardsQs = new CleanSchema({
  ...PaginationSchema,
  create_time__gte: get('create_time__gte').asISOString(),
  create_time__lt: get('create_time__lt').asISOString(),
  external_id: get('external_id').asString().ifEmptyString(undefined),
  fio: get('fio').asString().ifEmptyString(undefined),
});
